/* Images & vidéos → vrai dézoom */
const mediaElements = document.querySelectorAll(
  'main img, main video, main picture'
);

mediaElements.forEach(el => {
  const wrapper = el.parentElement;

  if (!wrapper) return;

  wrapper.classList.add('DezoomWrapper');
  el.classList.add('DezoomImage');
});

/* Autres blocs → fade simple */
const contentElements = document.querySelectorAll(
  'main section, main .shopify-section, main [data-section-id]'
);

contentElements.forEach(el => {
  if (!el.querySelector('img, video, picture')) {
    el.classList.add('FadeOnly');
  }
});

/* Observer */
const observer = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.15 }
);

/* Observe wrappers (important) */
document
  .querySelectorAll('.DezoomWrapper, .FadeOnly')
  .forEach(el => observer.observe(el));
